import React from "react";

const FieldIcon = ({
  type,
  placeholder,
  icon,
  label,
  value,
  onChange,
  tooltip,
}) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="relative flex items-center">
        {/* Input Field */}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="w-full py-2 pl-3 pr-10 text-sm text-gray-900 border rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />

        {/* Icon with Tooltip */}
        {icon && (
          <div className="relative group">
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer group">
              {React.isValidElement(icon) ? icon : <span>{icon}</span>}
              {tooltip && (
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block bg-black text-white text-xs rounded py-1 px-2">
                  {tooltip}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FieldIcon;
